import copy from 'copy-to-clipboard';
import React, {MouseEvent} from 'react';
import {Icon, Tooltip} from '@lightricks/react-design-system';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';
import type {CampaignCreatorRow} from '@/views/campaigns/creators-tab/types/creatorTabTypes';
import styles from './ShippingAddressCell.module.scss';

type ShippingAddressCellProps = {
  creator: CampaignCreatorRow;
};

function shippingLabel(creator: CampaignCreatorRow): string {
  return [creator.creatorName, creator.shippingAddressFormatted]
    .filter(Boolean)
    .join('\n');
}

function stopRowClick(event: MouseEvent) {
  event.stopPropagation();
}

function ShippingAddressCell({creator}: ShippingAddressCellProps) {
  const address = creator.shippingAddressFormatted;

  if (!address) {
    return null;
  }

  const copyLabel = translate('Copy Shipping Address');

  function handleCopy(event: MouseEvent) {
    stopRowClick(event);
    copy(shippingLabel(creator));
    raiseFlashMessage({
      status: 'success',
      message: translate('shipping-address-copied', {
        creatorName: creator.creatorName,
      }),
    });
  }

  return (
    <Tooltip title={copyLabel} arrow placement="top">
      <button
        type="button"
        className={styles.copyButton}
        onClick={handleCopy}
        onMouseDown={stopRowClick}
        aria-label={copyLabel}
        data-testid="copy-shipping-address"
      >
        <Icon
          name="Navigation-Copy"
          size="medium"
          appearance="neutral"
          color="currentColor"
        />
      </button>
    </Tooltip>
  );
}

export default ShippingAddressCell;
